import classNames from 'classnames';
import { Skeleton } from '@medifind/shared-basic-components';
import { getSmallClassList, getValueMediaBreakpointDown } from '@medifind/utils';
import styles from './CardConditionTier.module.scss';

const tierLabels = {
  1: 'Experienced',
  2: 'Advanced',
  3: 'Distinguished',
  4: 'Elite',
};

const CardConditionTier = ({ doctor, conditionName, smallAt = ['xs', 'sm', 'md'], style }) => {
  const { smallClassList } = getSmallClassList(smallAt, styles);
  const { score: overallScore } = doctor || {};
  const score = !!overallScore ? overallScore : null;

  // 4 tier system: (tier # being used for CSS)
  // --  0-24 = tier 1 "experienced"
  // -- 25-49 = tier 2 "advanced"
  // -- 50-74 = tier 3 "distinguished"
  // -- 75+   = tier 4 "elite"
  // how;
  // -- Math.min(x, 4) ensures maximum possible tier of 4
  // -- Math.floor(x + 1) creates first-inclusive/last-exclusive tiers (i.e. 0 <= x < 25)
  // -- x / 25 divides the score into 4 sub-sets (a percentile from 0-100; although nothing less than 5 will be given to the front-end)
  const tier = score !== 0 && score != null ? Math.min(Math.floor(score / 25) + 1, 4) : null;

  return (
    <div
      className={classNames(
        styles['condition-tier'],
        {
          ['hide--always']: doctor && (!tier || tier === 0),
        },
        smallClassList,
        styles[`tier-${tier}`],
      )}
      style={style ?? {}}
    >
      {doctor ? (
        <>
          {tierLabels[tier]}{' '}
          {conditionName && (
            <>
              in <span>{conditionName}</span>
            </>
          )}{' '}
        </>
      ) : (
        <Skeleton height={getValueMediaBreakpointDown({ xs: 20, sm: 80, md: 80, lg: 20, default: 80 })} />
      )}
    </div>
  );
};

export { CardConditionTier as default, CardConditionTier };
